import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const CoachListPage = () =>
  import('@modules/coach/components/coach-list-page.vue');
const CoachFormPage = () =>
  import('@modules/coach/components/coach-form-page.vue');
const CoachViewPage = () =>
  import('@modules/coach/components/coach-view-page.vue');
const CoachImporterPage = () =>
  import('@modules/coach/components/coach-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'coach',
        path: '/coach',
        component: CoachListPage,
        meta: {
          auth: true,
          permission: Permissions.values.coachView,
        },
      },
      {
        name: 'coachNew',
        path: '/coach/new',
        component: CoachFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.coachCreate,
        },
      },
      {
        name: 'coachImporter',
        path: '/coach/import',
        component: CoachImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.coachImport,
        },
      },
      {
        name: 'coachEdit',
        path: '/coach/:id/edit',
        component: CoachFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.coachEdit,
        },
        props: true,
      },
      {
        name: 'coachView',
        path: '/coach/:id',
        component: CoachViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.coachView,
        },
        props: true,
      },
    ],
  },
];
